var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17731",
    "data-name": "Group 17731",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9033",
    "data-name": "Rectangle 9033",
    fill: "none",
    stroke: "#d1d1d1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_facebook",
    "data-name": "vuesax/bold/facebook",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG_111",
    "data-name": "BG 111",
    d: "M0,0H20V20H0Z",
    fill: "none",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16,11.352A4.269,4.269,0,0,1,11.352,16H10.4a.8.8,0,0,1-.8-.8V10.584a.4.4,0,0,1,.392-.4L11.4,10.16a.255.255,0,0,0,.232-.2l.28-1.528a.242.242,0,0,0-.24-.28l-1.7.024a.407.407,0,0,1-.408-.392l-.032-1.96a.241.241,0,0,1,.24-.24l1.92-.032a.236.236,0,0,0,.24-.24L11.9,3.392a.236.236,0,0,0-.24-.24L9.5,3.184a2.4,2.4,0,0,0-2.36,2.44l.04,2.2a.4.4,0,0,1-.392.408l-.96.016a.236.236,0,0,0-.24.24l.024,1.52a.236.236,0,0,0,.24.24l.96-.016a.407.407,0,0,1,.408.392l.072,4.56a.8.8,0,0,1-.8.816H4.648A4.272,4.272,0,0,1,0,11.344v-6.7A4.269,4.269,0,0,1,4.648,0h6.7A4.269,4.269,0,0,1,16,4.648v6.7Z",
    transform: "translate(2 2)",
    fill: "rgb(9, 101, 254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H20V20H0Z",
    fill: "blue",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbb);
export default __webpack_public_path__ + "static/media/fbb.5ad48cf77e18b2cf39ae612fda19e845.svg";
export { ForwardRef as ReactComponent };